const styles = {
    custom_container: "w-10/12 hidden sm:block",
    heading: 'text-[27px] text-center md:text-start font-[600] font-Roboto pb-[20px]',
    section:'w-10/12 mx-auto',
    section1:'w-6/12 mx-auto',

    productTitle: 'text-[25px] font-[600] font-Roboto text-[#333]',
    productDiscountPrice:"font-bold text-[18px] text-[#333] font-Roboto",
    price:"font-[500] text-[16px] text-[#3F1B11] pl-3 mt-[-4px] line-through",
    shop_name:"pt-3 text-[15px] text-[#3F1B11] pb-3",
    active_indicator:"absolute bottom-[-27%] left-0 h-[3px] w-full bg-[#3F1B11]",
    button: 'w-[150px] bg-[#824e3f] h-[50px] my-3 flex items-center justify-center rounded-xl cursor-pointer',
    cart_button: "px-[20px] h-[38px] rounded-[20px] bg-[#3F1B11] flex items-center justify-center cursor-pointer",
    cart_button_text:"text-[#fff] text-[16px] font-[600]",
    input:"w-full border p-1 rounded-[5px]",
    activeStatus:"w-[10px] h-[10px] rounded-full absolute top-0 right-1 bg-[#40d132]",
    noramlFlex:"flex items-center",
    noramlFlexx:"items-center justify-center font-[600]"

  };
  
  export default styles;